var map = {
	"./music-instructions.json": 4472,
	"./music-library-intro2024.json": 4473,
	"./music-library-launch2024.json": 4474,
	"./music-progression.json": 4475,
	"./startSourcesAdvanced.json": 4476,
	"./startSourcesSimple.json": 4477,
	"./startSourcesSimple2.json": 4478,
	"./startSourcesTracks.json": 4479
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4252;